export const LOGIN_LANDING_PAGE = '/projects';
